module.exports = __webpack_public_path__ + "assets/images/home.c415fb97.svg";